import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import MainLayout from '../components/layout/MainLayout';
import Section from '../components/ui/Section';
import Button from '../components/ui/Button';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import supabase from '../supabase/supabase';

const Verify = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');
      const email = searchParams.get('email');

      if (!token || !email) {
        setStatus('error');
        setMessage('Missing verification details. Please check your link.');
        return;
      }

      try {
        const { data, error } = await supabase
          .from('newsletter_subscribers_1779580000000')
          .update({ is_verified: true })
          .match({ email, verification_token: token });

        if (error) throw error;
        
        setStatus('success');
      } catch (err) {
        console.error('Verification error:', err);
        setStatus('error');
        setMessage('We couldn\'t verify your email. The link may have expired.');
      }
    };

    verifyEmail();
  }, [searchParams]);

  return (
    <MainLayout>
      <Section bg="cream" className="min-h-[60vh] flex items-center">
        <div className="max-w-md mx-auto w-full text-center bg-white p-10 rounded-3xl shadow-sm border border-gray-100">
          {status === 'verifying' && (
            <div className="animate-pulse">
              <div className="w-16 h-16 bg-gray-100 rounded-full mx-auto mb-6 flex items-center justify-center">
                <SafeIcon icon={FiIcons.FiLoader} className="w-8 h-8 text-brand-teal animate-spin" />
              </div>
              <h2 className="text-2xl font-bold text-brand-navy">Verifying...</h2>
            </div>
          )}

          {status === 'success' && (
            <div className="animate-fade-in">
              <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full mx-auto mb-6 flex items-center justify-center">
                <SafeIcon icon={FiIcons.FiCheck} className="w-8 h-8" />
              </div>
              <h2 className="text-2xl font-bold text-brand-navy mb-4">Subscription Verified!</h2>
              <p className="text-gray-600 mb-8">You're all set. Welcome to the community.</p>
              <Button to="/" variant="primary" fullWidth>Go to Homepage</Button>
            </div>
          )}

          {status === 'error' && (
            <div className="animate-fade-in">
              <div className="w-16 h-16 bg-red-100 text-red-600 rounded-full mx-auto mb-6 flex items-center justify-center">
                <SafeIcon icon={FiIcons.FiX} className="w-8 h-8" />
              </div>
              <h2 className="text-2xl font-bold text-brand-navy mb-4">Verification Failed</h2>
              <p className="text-gray-600 mb-8">{message}</p>
              <Button to="/newsletter" variant="outline" fullWidth>Try Signing Up Again</Button>
            </div>
          )}
        </div>
      </Section>
    </MainLayout>
  );
};

export default Verify;